module.exports = __webpack_public_path__ + "static/media/header-small.868c4253.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header-small.png
// module id = 575
// module chunks = 0